export default __webpack_public_path__ + "static/media/table.a0356048.svg";